import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import { Easing } from '@tweenjs/tween.js';
import Sprite from '../../../Prototype/Sprite';
import { Point } from 'pixi.js';
import { AwaitIterators } from '../AnimationHelper';
import {
    createScaleTween,
    getTweenProps,
    createAlphaTween,
    createPositionTween,
} from '../AnimationTweenHelper';
import Game from '../../../Game';

export class RemainingCardBonusEffect extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: any
    ): IterableIterator<number> {
        this.gameObject.container.scale.set(0, 0);
        const levelState = Game.store.getState().levelState;

        const star = GameObject.Instantiate(Sprite, {
            texture: meta.texture,
            anchor: new Point(0.5, 0.5),
            scale: new Point(0.7, 0.7),
        });
        this.gameObject.addChild(star);

        const halo = GameObject.Instantiate(Sprite, {
            texture: 'halo',
            anchor: new Point(0.5, 0.5),
            scale: new Point(0, 0),
        });

        const haloRing = GameObject.Instantiate(Sprite, {
            texture: 'halo-ring',
            anchor: new Point(0.5, 0.5),
        });

        halo.addChild(haloRing);
        this.gameObject.addChild(halo);

        const scaleTween = createScaleTween({
            ...getTweenProps(this.gameObject, this, new Point(1, 1)),
            duration: 400,
            easing: Easing.Back.InOut,
        });

        const alphaTween = createAlphaTween({
            ...getTweenProps(this.gameObject, this, { alpha: 0 }),
            delay: 1000,
            duration: 600,
            easing: Easing.Quadratic.Out,
        });

        const haloScaleTween = createScaleTween({
            ...getTweenProps(halo, this, new Point(1.2, 1.2)),
            duration: 800,
            easing: Easing.Quadratic.Out,
        });

        const haloAlphaTween = createAlphaTween({
            ...getTweenProps(halo, this, { alpha: 0 }),
            duration: 600,
            delay: 400,
            easing: Easing.Quadratic.Out,
        });

        yield* AwaitIterators([
            this.startTween(haloScaleTween),
            this.startTween(haloAlphaTween),
            this.startTween(scaleTween),
            this.startTween(alphaTween),
            this.sparkles(),
        ]);

        this.gameObject.destroy();
    }

    private *sparkles(): IterableIterator<number> {
        const nSparkles = 15;
        const step = (2 * Math.PI) / nSparkles;

        const tweens: IterableIterator<number>[] = [];

        for (let i = 0; i < nSparkles; i++) {
            const starVFX = GameObject.Instantiate(Sprite, {
                texture: 'coin-vfx',
                anchor: new Point(0.5, 0.5),
                position: {
                    x: Math.cos(i * step) * 10,
                    y: Math.sin(i * step) * 10,
                },
            });
            this.gameObject.addChild(starVFX);

            const delay = i % 2 ? 100 : 40;
            const duration = Math.floor(Math.random() * 400) + 400;
            const radio = i % 2 ? 85 : 65;

            const tweenPosition = createPositionTween({
                ...getTweenProps(
                    starVFX,
                    this,
                    new Point(
                        Math.cos(i * step) * radio,
                        Math.sin(i * step) * radio
                    )
                ),
            });

            const tweenScale = createScaleTween({
                ...getTweenProps(starVFX, this, new Point(0, 0)),
                delay,
                duration,
            });

            tweens.push(
                ...[this.startTween(tweenPosition), this.startTween(tweenScale)]
            );
        }
        yield* AwaitIterators(tweens);
    }
}
